import {DateFormat, formatDateFns, subDate} from '@shared/helpers/date'

export const getDateText = (date: Maybe<Date>) => {
    return date ? (formatDateFns(date, DateFormat['yyyy-MM-dd']) ?? '') : ''
}

export const getDateMinMaxDate = () => {
    const today = new Date()
    const minDate = subDate(today, {year: 5})
    const maxDate = today
    const minDateText = getDateText(minDate)
    const maxDateText = getDateText(maxDate)
    return {
        minDate,
        minDateText,
        maxDate,
        maxDateText,
        isRange: (date: Date): boolean => {
            const dateText = getDateText(date)
            return minDateText <= dateText && dateText <= maxDateText
        },
    }
}
